import React from 'react';

import { LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export function FileCard({ fileName, onDelete }) {
  return (
    <div className="fw flex bg-F5F5F5 padding-12 jc-space-between br-6 file_card">
      <div className="flex gap-10 fs-11 ai-center">
        <LinkOutlined />
        <span>{fileName}</span>
      </div>
      <Button onClick={onDelete} size="small" icon={<DeleteOutlined />} />
    </div>
  );
}
